// extracted by mini-css-extract-plugin
module.exports = {"inputTag":"InputTag_inputTag__344cp","error":"InputTag_error__86VKQ"};